import { useQuery } from "react-query";
import axios from "infra/http";
import { ConsumoPdfQueryParams, PdfConsumoUnidadeResponse } from "../typings";

function usePdfConsumoUnidades(
  consumoId?: string,
  params?: ConsumoPdfQueryParams & { consumoAnteriorId?: string | null },
  enabled = false
) {
  return useQuery(
    [`/v1/relatorios/financeiro/consumo/${consumoId}/pdf`, params],
    async () => {
      const { data } = await axios.get<PdfConsumoUnidadeResponse>(
        `/v1/relatorios/financeiro/consumo/${consumoId}/pdf`,
        {
          params,
        }
      );

      return data;
    },
    {
      enabled: !!consumoId && !!enabled,
    }
  );
}

export default usePdfConsumoUnidades;
